module.exports = __webpack_public_path__ + "img/background04.e0c9f5eb.png";